import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import bankBranchService from "../../services/BranchService";


export const getBankBranchList = createAsyncThunk(
    "bankBranch/getBankBranchList",
    async (_,{ rejectWithValue }) => {
        try {
            const response = await bankBranchService.GetBranchList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to get bank branch list"
            );
        }
    }
)

export const addBankBranch = createAsyncThunk(
    "bankBranch/addBankBranch",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await bankBranchService.AddBranch(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to add bank branch"
            );
        }
    }
)

export const updateBankBranch = createAsyncThunk(
    "bankBranch/updateBankBranch",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await bankBranchService.UpdateBranch(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to update bank branch"
            );
        }
    }
)

const initialState = {
  bankBranches: [],

  loading: false,

  saving: false,

  error: null,
  success: false,
};

const bankBranchSlice = createSlice({
    name: "bankBranch",
    initialState,
    reducers: {
        clearBankBranchError: (state) => {
            state.error = null;
        },

        clearBankBranchSuccess: (state) => {
            state.success = false;
        },

        clearBankBranches: (state) => {
            state.bankBranches = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get bank list
        .addCase(
            getBankBranchList.pending,
            (state) => {
                state.loading = true;
                state.error = null;
            }
        )
        .addCase(
            getBankBranchList.fulfilled,
            (state, action) => {
                state.loading = false;
                state.bankBranches = action.payload;
            }
        )
        .addCase(
            getBankBranchList.rejected,
            (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load bank branches";
            }
        )

        // Add bank
        .addCase(addBankBranch.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addBankBranch.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(addBankBranch.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add bank branch"
        })

        // Update bank
        .addCase(updateBankBranch.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateBankBranch.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(updateBankBranch.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update bank branch"
        })
    }
})

export const {
    clearBankBranchError,
    clearBankBranchSuccess,
    clearBankBranches
} = bankBranchSlice.actions;

export default bankBranchSlice.reducer;